import React, { useState } from 'react';
import './App.css';
import { ArrowUpwardRounded } from '@mui/icons-material'
import workChat from './assets/work-chat.svg'
import messaging from './assets/messaging.svg'
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';

function App () {
  const [visible, setVisible] = useState(false)

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 500)
    {
      setVisible(true)
    }
    else if (scrolled <= 500)
    {
      setVisible(false)
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <div>
      <div className="md:h-screen lg:w-3/4 relative bg-gradient-to-br from-slate-700 to-slate-500 top-container" >
        <img className='absolute opacity-20 h-full bg-img' src={workChat} alt="chat" />
        <div className=" flex h-full flex-col px-10 md:px-20 lg:px-36">
          <nav className='flex py-4 z-10'>
            <b className='text-white font-serif'>QUICKROOM</b>
          </nav>
          <div className='my-auto z-10 py-36 md:py-0'>
            <h3 className='mb-5 font-bold text-5xl sm:text-6xl md:text-7xl font-serif text-white max-w-md'>Talking with everyone real time.</h3>
            <p className='max-w-sm text-zinc-100'>An app for quick meetings, class , etc. Share text, links and files with small size easily.</p>
            <span className='pr-4'>
              <Link to="/new?opt=create"><Button style={{ width: "10rem", marginTop: '1rem' }} color='secondary' variant='contained'>Create Room</Button></Link>
            </span>
            <Link to="/new?opt=join"><Button style={{ width: "10rem", marginTop: '1rem' }} variant="contained">Join a Room</Button></Link>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row px-10 md:px-20 lg:px-36 py-10 md:py-20">
        <img className='h-full bg-img mb-10 md:w-1/3 lg:w-1/2 my-auto' src={messaging} alt="chat" />
        <div className="bg-slate-100 md:ml-20 h-auto flex flex-col md:w-2/3 lg:w-1/2 px-10 py-20 text-center">
          <div className='my-auto lg:px-10'>
            <h3 className='font-bold font-serif text-3xl text-slate-600 mb-10'>Quickroom</h3>
            <p className='text-lg text-slate-700'>Quickroom gives you a feature to quickly create chat room with unique id that you can share with others to join chat room</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row-reverse px-10 md:px-20 lg:px-36 py-10 md:py-20">
        <img className='h-full bg-img md:ml-20 mb-10 md:w-1/3 lg:w-1/2 my-auto' src={messaging} alt="chat" />
        <div className="bg-slate-100  h-auto flex flex-col md:w-2/3 lg:w-1/2 px-10 py-20 text-center">
          <div className='my-auto lg:px-10'>
            <h3 className='font-bold font-serif text-3xl text-slate-600 mb-10'>Quickroom</h3>
            <p className='text-lg text-slate-700'>Quickroom gives you a feature to quickly create chat room with unique id that you can share with others to join chat room</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row px-10 md:px-20 lg:px-36 py-10 md:py-20">
        <img className='h-full bg-img mb-10 md:w-1/3 lg:w-1/2 my-auto' src={messaging} alt="chat" />
        <div className="bg-slate-100 md:ml-20 h-auto flex flex-col md:w-2/3 lg:w-1/2 px-10 py-20 text-center">
          <div className='my-auto lg:px-10'>
            <h3 className='font-bold font-serif text-3xl text-slate-600 mb-10'>Quickroom</h3>
            <p className='text-lg text-slate-700'>Quickroom gives you a feature to quickly create chat room with unique id that you can share with others to join chat room</p>
          </div>
        </div>
      </div>
      <footer className='bg-gradient-to-br from-slate-600 to-slate-700 px-10 md:px-20 lg:px-36 py-5 flex'>
        <b className='text-white font-serif text-xl'>{new Date().getFullYear()} &copy; QUICKROOM</b>

        <a href='htts://licode.vercel.app' className='text-slate-300 text-sm italic ml-auto'>Licode</a>
      </footer>
      {visible && <Button variant='contained' style={{ position: 'fixed', bottom: '1rem', right: '1rem', maxWidth: '.5rem', minWidth: '.5rem' }} onClick={scrollToTop}><ArrowUpwardRounded /></Button>}
    </div>
  );
}

export default App;